import { useEffect, useState } from "react";

export function useNetworkState() {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const updateNetworkState = () => setIsOnline(navigator.onLine);

    window.addEventListener("offline", updateNetworkState);
    window.addEventListener("online", updateNetworkState);

    return () => {
      window.removeEventListener("offline", updateNetworkState);
      window.removeEventListener("online", updateNetworkState);
    };
  }, [setIsOnline]);

  return { isOnline };
}
